import { Box, Typography, Paper, LinearProgress, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface UploadStatusOverlayProps {
  isUploading: boolean;
  isProcessing?: boolean;
  isUploadingDocuments?: boolean;
  progress: number;
  documentProgress?: number;
  fileCount: number;
  onCancel?: () => void;
}

function UploadStatusOverlay({ 
  isUploading, 
  isProcessing = false, 
  isUploadingDocuments = false, 
  progress, 
  documentProgress = 0, 
  fileCount, 
  onCancel 
}: UploadStatusOverlayProps) {
  if (!isUploading && !isProcessing && !isUploadingDocuments) return null;
  
  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        width: 300,
        p: 2,
        zIndex: 1300,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1">
          {isProcessing ? `Processing ${fileCount} images` : 
           isUploadingDocuments ? `Uploading ${fileCount} documents` :
           `Uploading ${fileCount} files`}
        </Typography>
        {onCancel && !isProcessing && !isUploadingDocuments && (
          <IconButton size="small" onClick={onCancel}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      
      {isProcessing ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 1 }}>
          <CircularProgress size={24} sx={{ mr: 2 }} />
          <Typography variant="body2" color="text.secondary">
            Analyzing images...
          </Typography>
        </Box>
      ) : (
        <>
          <LinearProgress variant="determinate" value={isUploadingDocuments ? documentProgress : progress} sx={{ mb: 1 }} />
          <Typography variant="body2" color="text.secondary" align="center">
            {isUploadingDocuments ? documentProgress : progress}% Complete
          </Typography>
        </>
      )}
    </Paper>
  );
}

export default UploadStatusOverlay;